import { NgModule } from '@angular/core';
import { SaveModuleDialogComponent } from './save-module-dialog.component';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    SaveModuleDialogComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    SharedModule,
    ReactiveFormsModule
  ],
  exports: [
    SaveModuleDialogComponent
  ],
  entryComponents: [
    SaveModuleDialogComponent
  ]
})
export class SaveModuleDialogModule { }
